jQuery(document).ready(function ($) {

    /* slider initialization */
    if ($('.TestimonialSliderWithText-slider-wrap').length > 0)
        $('.TestimonialSliderWithText-slider-wrap').each(function () {

            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                cssEase: "linear",
                dots: true,
                arrows: false,
            });
        })
});